import React from 'react';
import ReactDOM from 'react-dom';
import angular from 'angular';
import { CallMenuButton } from './CallMenuButton';
import { withProviders } from '../../../core/components';
export default angular
    .module('doxy.call.call-menu-button', [])
    .component('callMenuButton', {
    // call-menu-button
    bindings: {
        onToggle: '<',
        isPatient: '<',
    },
    template: `<div></div>`,
    controller: function ($element) {
        const reactContainer = $element[0];
        const render = () => {
            ReactDOM.render(React.createElement(withProviders(CallMenuButton), {
                onToggle: this.onToggle,
                isPatient: this.isPatient,
            }), reactContainer);
        };
        this.$onInit = render;
        this.$onDestroy = () => ReactDOM.unmountComponentAtNode(reactContainer);
    },
}).name;
